<template>
  <v-card class="pa-3">
    <v-card-title class="headline pl-2 py-0">Update Sub Drivers</v-card-title>

    <div v-if="!selected.length" class="title text-xs-center">
      Please select absents from the current season

      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn dark color="default" @click="closeUpdateDialog()">Close</v-btn>
      </v-card-actions>
    </div>

    <div v-if="selected.length">
      <div v-if="!showConfirmView">
        <v-card style="background-color: #5cb860" class="mt-2 mx-1">
          <v-layout row>
            <div
              class="pa-3 pt-4 mt-1 display-1 font-weight-light"
              style="width: 32%; color: #fff"
            >
              Default Values
            </div>
            <v-card-actions
              class="pb-3 my-2 mx-3 pr-2"
              style="width: 74%; background-color: #fff; border-radius: 3px;"
            >
              <v-layout row>
                <v-select
                  style="width: 15%;"
                  class="mr-2 ml-4 my-0"
                  v-model="geoUpdated"
                  label="GEO Updated"
                  :items="['YES', 'NO', 'N/A']"
                  hide-details
                  @change="updateGeoUpdated"
                ></v-select>
                <v-select
                  style="width: 20%;"
                  class="mr-2 my-0"
                  v-model="notifiedDriver"
                  label="Notified Driver"
                  :items="['YES', 'NO', 'N/A']"
                  @change="updateNotifiedDriver"
                  hide-details
                ></v-select>

                <v-autocomplete
                  style="padding-top: 2px !important; width: 25%;"
                  v-model="selectedSubDriver"
                  :disabled="isUpdatingSubDriversList"
                  :items="subDriversDisplayList"
                  hide-details
                  chips
                  color="success"
                  class="mr-2 pt-0 my-0"
                  label="Select"
                  item-text="displayName"
                  item-value="id"
                  clearable
                  @change="updateSubDriver"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      class="chip--select-multi"
                      @input="removeSubDriver(data.item)"
                    >
                      {{ data.item.displayName }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content
                        v-text="data.item"
                      ></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="data.item.displayName"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="data.item.group"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  style="width: 25%;"
                  class="my-0"
                  v-model="absentReason"
                  label="Reason"
                  :items="reasons.map((r) => r.reason)"
                  @change="updateAbsentReason"
                  hide-details
                ></v-autocomplete>
              </v-layout>
            </v-card-actions>
          </v-layout>
        </v-card>
        <v-divider></v-divider>
        <v-card-text class="py-2 px-0 mt-3 scroll mx-2" style="height: 500px;">
          <div v-for="(absent, index) in sortedSelected" class="student-line">
            <v-layout row class="mb-2 mt-0">
              <div style="width: 325px;" class="mr-3">
                <div class="font-weight-regular">
                  {{ absent.date | date }}
                </div>
                <div class="font-weight-medium">
                  Driver - Bus:
                  {{ absent.driver + " (" + absent.busNumber + ")" }}
                </div>
                <div class="caption" v-if="absent.route_ID">
                  {{
                    absent.timeStart +
                      " - " +
                      absent.routeIdentifier +
                      " - " +
                      absent.groupBy
                  }}
                </div>
                <v-chip
                  v-if="canEditExistingDeductions"
                  small
                  label
                  :class="deductionChipClass(absent)"
                  class="mt-1 deduction-status-chip"
                >
                  {{ deductionChipText(absent) }}
                </v-chip>
              </div>

              <v-select
                style="width: 100px;"
                class="mr-2 ml-4"
                v-model="absent.geoUpdated"
                label="GEO Updated"
                :items="['YES', 'NO', 'N/A']"
                hide-details
              ></v-select>
              <v-select
                style="width: 100px;"
                class="mr-2"
                v-model="absent.notifiedDriver"
                label="Notified Driver"
                :items="['YES', 'NO', 'N/A']"
                hide-details
              ></v-select>

              <v-autocomplete
                v-model="absent.selectedSubDriver"
                :disabled="absent.isUpdatingSubDriversList"
                :items="subDriversDisplayList"
                hide-details
                chips
                color="success"
                class="mr-2"
                style="padding-top: 2px; width: 250px"
                label="Select"
                item-text="displayName"
                item-value="id"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    class="chip--select-multi"
                    @input="removeSubDriver(data.item, absent)"
                  >
                    {{ data.item.displayName }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content
                      v-text="data.item"
                    ></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.displayName"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.group"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>

              <v-autocomplete
                v-model="absent.absentReason"
                label="Reason"
                :items="reasons.map((r) => r.reason)"
                ref="absentReason"
                :rules="[rules.required]"
                style="width: 200px;"
              ></v-autocomplete>

              <v-text-field
                class="ml-2"
                v-model="absent.calendarNote"
                label="Calendar Note"
                ref="calendarNote"
              ></v-text-field> </v-layout
            ><v-divider
              class="mt-0 mb-2 pb-1"
              v-if="index + 1 < sortedSelected.length"
              :key="index"
            ></v-divider>
          </div>
        </v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="closeUpdateDialog()"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="continueToConfirm()"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else>
        <div
          class="headline font-weight-regular text-warning mb-4 text-xs-center"
        >
          Please confirm the details below
        </div>
        <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
          <div height="50" v-for="(absent, index) in sortedSelected">
            <v-layout row class="font-weight-regular">
              <div style="width: 325px;" class="mr-3">
                <div class="font-weight-regular">
                  {{ absent.date | date }}
                </div>
                <div class="font-weight-medium">
                  Driver - Bus:
                  {{ absent.driver + " (" + absent.busNumber + ")" }}
                </div>
                <div class="caption" v-if="absent.route_ID">
                  {{
                    absent.timeStart +
                      " - " +
                      absent.routeIdentifier +
                      " - " +
                      absent.groupBy
                  }}
                </div>
              </div>
              <div
                style="width: 150px; text-align: right;"
                class="mx-3 pt-4 text-xs-center"
              >
                {{ "GEO Updated: " + absent.geoUpdated }}
              </div>
              <div style="width: 150px;" class="mx-3 text-xs-center pt-4">
                {{ "Notified Driver: " + absent.notifiedDriver }}
              </div>
              <div style="width: 250px" class="mx-3 text-xs-center pt-4">
                {{ "Sub Driver: " + getDriverByID(absent.selectedSubDriver) }}
              </div>
              <div style="width: 200px;" class="mx-3 text-xs-center pt-4">
                {{ "Reason: " + absent.absentReason }}
              </div>
              <div class="mx-3 text-xs-center pt-4">
                {{ "Note: " + absent.calendarNote }}
              </div>
            </v-layout>
            <v-divider
              class="mt-2 mb-2 pb-1"
              v-if="index + 1 < sortedSelected.length"
              :key="index"
            ></v-divider>
          </div>
        </v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="closeUpdateDialog()"
            >Cancel</v-btn
          >
          <v-btn color="default" outline @click="showConfirmView = false"
            >Back</v-btn
          >
          <v-btn :loading="processing" color="success" @click="save()">
            Save
          </v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-card>
</template>
<script>
import moment from "moment";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";
import { canEditExistingDeductions } from "./deductionAccess";

export default {
  props: {
    selected: Array,
    reload: Function,
    closeUpdateDialog: Function,
  },
  data() {
    return {
      processing: false,
      subDriversDisplayList: [],
      subDrivers: [],
      selectedSubDriver: "",
      isUpdatingSubDriversList: false,
      subDriverListFilter: "all",
      geoUpdated: "",
      notifiedDriver: "",
      absentReason: "",
      reasons: [],

      // Read-only deduction status per absent ID, keyed by absent.id — view only, this
      // dialog never edits deductions (see AbsentDeductionPanel / UpdateAbsent for that).
      deductionSummaries: {},

      showConfirmView: false,

      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  async created() {
    this.loadReasons();
  },
  computed: {
    canEditExistingDeductions() {
      return canEditExistingDeductions(this.$store);
    },
    sortedSelected() {
      return [...this.selected].sort((a, b) => {
        // First sort by bus number
        const busNumberA = parseInt(a.busNumber) || 0;
        const busNumberB = parseInt(b.busNumber) || 0;
        if (busNumberA !== busNumberB) {
          return busNumberA - busNumberB;
        }

        // Then sort by date
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        if (dateA.getTime() !== dateB.getTime()) {
          return dateA - dateB;
        }

        // Finally sort by time start (handle AM/PM)
        if (a.timeStart && b.timeStart) {
          return (
            this.parseTimeToMinutes(a.timeStart) -
            this.parseTimeToMinutes(b.timeStart)
          );
        }

        return 0;
      });
    },
  },
  watch: {
    selected(newValue, oldValue) {
      this.loadSubDriverList();
      this.loadDeductionSummaries();
    },
  },
  methods: {
    parseTimeToMinutes(timeStr) {
      if (!timeStr) return 0;

      // Parse time format like "7:45 AM" or "12:00 PM"
      const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
      if (!match) return 0;

      let hours = parseInt(match[1]);
      const minutes = parseInt(match[2]);
      const period = match[3].toUpperCase();

      // Convert to 24-hour format
      if (period === "AM") {
        if (hours === 12) hours = 0; // 12 AM is midnight
      } else {
        if (hours !== 12) hours += 12; // PM hours except 12 PM
      }

      return hours * 60 + minutes;
    },
    async loadReasons() {
      this.reasons = await this.$http.get(
        "api/driverAbsent/GetDriverAbsentReasons"
      );
    },
    async loadSubDriverList() {
      const absentIDs = this.selected.map((d) => d.id);

      const response = await this.$http.post(
        "api/driverAbsent/getSubDrivers",
        absentIDs
      );

      this.subDrivers = response
        .map((driver) => {
          driver.displayName =
            (driver.nameH ? driver.nameH : driver.name) +
            " (" +
            driver.busNumber +
            ")";

          driver.group = driver.isOccupied ? "Occupied" : "Not Occupied";

          if (driver.position == "Substitute")
            driver.group += ` <span class='substitute-option'>Substitute</span>`;

          return driver;
        })
        .sort((a, b) => {
          // First sort by group
          if (a.group < b.group) return -1;
          if (a.group > b.group) return 1;

          // If groups are equal, sort by busNumber
          if (a.busNumber < b.busNumber) return -1;
          if (a.busNumber > b.busNumber) return 1;

          return 0;
        });

      this.subDrivers = this.subDrivers.reduce((acc, curr) => {
        const { group } = curr;

        let groupHeader = group;

        groupHeader = groupHeader.replace(
          ` <span class='substitute-option'>Substitute</span>`,
          ``
        );

        const foundIndex = acc.findIndex((item) => item.group === groupHeader);

        // if group is not yet added
        if (foundIndex === -1) {
          // add divider after full list of Not Occupied
          if (group === "Occupied") {
            acc.push({ divider: true });
          }
          acc.push({ header: groupHeader.toUpperCase() });
        }
        acc.push(curr);
        return acc;
      }, []);

      this.subDriversDisplayList = this.subDrivers;
    },
    // View-only: fetches whether each selected absent's day already has a deduction (and its
    // amount/preset) so the row can show a status chip. Never used to edit anything here.
    async loadDeductionSummaries() {
      this.deductionSummaries = {};

      if (!this.canEditExistingDeductions || !this.selected.length) return;

      try {
        const absentIds = this.selected.map((a) => a.id);
        const response = await this.$http.post(
          "api/driverAbsent/getDeductionSummaries",
          absentIds
        );

        const map = {};
        (response || []).forEach((row) => {
          map[row.absentID] = row;
        });
        this.deductionSummaries = map;
      } catch (e) {
        this.deductionSummaries = {};
      }
    },
    deductionChipText(absent) {
      const summary = this.deductionSummaries[absent.id];
      if (!summary) return "Deduction: —";
      if (!summary.hasDeduction) return "No deduction yet";
      return "Deduction: $" + Number(summary.amount || 0).toFixed(2);
    },
    deductionChipClass(absent) {
      const summary = this.deductionSummaries[absent.id];
      if (!summary || !summary.hasDeduction) {
        return "deduction-status-chip--missing";
      }
      return "deduction-status-chip--set";
    },
    getDriverByID(id) {
      if (!id) return "";

      return this.subDrivers.find((s) => s.id == id).displayName;
    },
    removeSubDriver(item, absent = null) {
      if (absent) {
        absent.selectedSubDriver = "";

        const item = this.selected.find((s) => s.id == absent.id);

        item.selectedSubDriver = "";

        this.$forceUpdate();

        return;
      }

      this.selectedSubDriver = "";
      this.updateSubDriver("");
    },
    updateGeoUpdated(value) {
      this.selected.forEach((absent) => (absent.geoUpdated = value));
    },
    updateNotifiedDriver(value) {
      this.selected.forEach((absent) => (absent.notifiedDriver = value));
    },
    updateSubDriver(value) {
      this.selected.forEach((absent) => (absent.selectedSubDriver = value));
    },
    updateAbsentReason(value) {
      this.selected.forEach((absent) => (absent.absentReason = value));
    },
    continueToConfirm() {
      const validations = this.$refs.absentReason.map((r) => !r.validate(true));

      if (validations.some(Boolean)) return;

      this.showConfirmView = true;
    },
    async save() {
      try {
        this.processing = true;

        const data = this.selected.map((absent) => {
          const subDriver = this.subDrivers.find(
            (sd) => sd.id == absent.selectedSubDriver
          );

          absent.subDriver_Bus_ID = subDriver ? subDriver.id : "";
          absent.absentReasonID = this.getReasonID(absent.absentReason);
          // absent.notifiedDriver = this.notifiedDriver;
          // absent.geoUpdated = this.geoUpdated;

          return absent;
        });

        await this.$http.post("api/driverAbsent/save", data);

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.updateSubDriverDialog = false;
        this.processing = false;
        this.selectedSubDriver = "";
        this.notifiedDriver = "";
        this.showConfirmView = false;
        this.geoUpdated = "";

        this.closeUpdateDialog();
        this.reload();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getReasonID(reason) {
      const data = this.reasons.find((r) => r.reason == reason);

      return data ? data.id : null;
    },
  },
};
</script>
<style>
.scroll-container {
  height: 100%;
  overflow-y: scroll;
  backface-visibility: hidden;
}
.deduction-status-chip.v-chip {
  height: 20px;
  font-size: 11px;
}
.deduction-status-chip--set.v-chip {
  background-color: #e8f5e9 !important;
  color: #2e7d32 !important;
}
.deduction-status-chip--missing.v-chip {
  background-color: #ffebee !important;
  color: #c62828 !important;
}
.substitute-option {
  font-size: 12px;
  background-color: purple;
  color: #fff;
  width: fit-content;
  padding: 3px;
  margin-bottom: 2px;
  border-radius: 5px;
}
</style>
